import React from "react";
import {
  MdArrowDropUp,
  MdOutlineCalendarToday,
  MdBarChart,
} from "react-icons/md";
import Card from "components/card";
import {
  lineChartDataTotalSpent,
  lineChartOptionsTotalSpent,
} from "variables/charts";
import LineChart from "components/charts/LineChart";

const TotalSpent = () => {
  return (
    <Card extra="!p-[20px] text-center">
      <div className="flex justify-between">
        <button className="linear mt-1 flex items-center justify-center gap-2 rounded-lg bg-lightPrimary p-2 text-gray-600 transition duration-200 hover:cursor-pointer hover:bg-gray-100 active:bg-gray-200 dark:bg-navy-700 dark:hover:opacity-90 dark:active:opacity-80">
          <MdOutlineCalendarToday />
          <span className="text-sm font-medium text-gray-600">This month</span>
        </button>
        <button className="!linear z-[1] flex items-center justify-center rounded-lg bg-lightPrimary p-2 text-brand-500 !transition !duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10">
          <MdBarChart className="h-6 w-6" />
        </button>
      </div>

      <div className="flex h-full w-full flex-row justify-between sm:flex-wrap lg:flex-nowrap 2xl:overflow-hidden">
        <div className="flex flex-col">
          <p className="mt-[20px] text-3xl font-bold text-navy-700 dark:text-white">
            $37.5K
          </p>
          <div className="flex flex-col items-start">
            <p className="mt-2 text-sm text-gray-600">Total Spent</p>
            <div className="flex flex-row items-center justify-center">
              <MdArrowDropUp className="font-medium text-green-500" />
              <p className="text-sm font-bold text-green-500"> +2.45% </p>
            </div>
          </div>
        </div>
        <div className="h-full w-full">
          <LineChart
            options={lineChartOptionsTotalSpent}
            series={lineChartDataTotalSpent}
          />
        </div>
      </div>

      <div className="flex justify-center gap-4 mt-4">
        <a href="https://www.meta.ai/" target="_blank" rel="noopener noreferrer">
          <button className="flex items-center justify-center rounded-full bg-gray-600 p-3 hover:bg-gray-700">
            <img src="https://files.catbox.moe/yyxfuc.jpg" alt="Meta AI" className="w-6 h-6" />
          </button>
        </a>
        <a href="https://www.gpt.com/ilami" target="_blank" rel="noopener noreferrer">
          <button className="flex items-center justify-center rounded-full bg-gray-600 p-3 hover:bg-gray-700">
            <img src="https://files.catbox.moe/h5rq19.jpg" alt="GPT Ilami" className="w-6 h-6" />
          </button>
        </a>
        <a href="https://www.qgom.com/gpt" target="_blank" rel="noopener noreferrer">
          <button className="flex items-center justify-center rounded-full bg-gray-600 p-3 hover:bg-gray-700">
            <img src="https://picsum.photos/200" alt="Qgom GPT" className="w-6 h-6" />
          </button>
        </a>
        <a href="https://www.gpt.ilami.com" target="_blank" rel="noopener noreferrer">
          <button className="flex items-center justify-center rounded-full bg-gray-600 p-3 hover:bg-gray-700">
            <img src="https://picsum.photos/200" alt="GPT Ilami" className="w-6 h-6" />
          </button>
        </a>
        <a href="https://www.qgom.ilami.com/gpt" target="_blank" rel="noopener noreferrer">
          <button className="flex items-center justify-center rounded-full bg-gray-600 p-3 hover:bg-gray-700">
            <img src="https://picsum.photos/200" alt="Qgom Ilami GPT" className="w-6 h-6" />
          </button>
        </a>
      </div>
    </Card>
  );
};

export default TotalSpent;

